import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Carrier from './carrier';
import Planslucky from './planslucky';
import Planschatr from './planschatr';
import Infoform from './infoform';
import Topup from './topup';
import Formtopup from './formtopup';
import Mainpage from './mainpage';
import Planskoodo from './planskoodo';

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route path='/' element={<Mainpage />} />
          <Route path='/carrier' element={<Carrier />} />
          <Route path='/planslucky' element={<Planslucky />} />
          <Route path='/planschatr' element={<Planschatr />} />
          <Route path='/infoform' element={<Infoform />} />
          <Route path='/topup' element={<Topup />} />
          <Route path='/formtopup' element={<Formtopup />} />
          <Route path='/planskoodo' element={<Planskoodo />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
export default App;
